import React from "react";
import Txn from "./Txn";
import { ListHeader, OpenCloseBalance } from "components";

const TxnsTView = ({
  txns = [],
  monthlyCash = { in: "₹ 0", out: "₹ 0" },
  openBalance = 0,
  closeBalance = 0,
  handleToggle,
  setLoading,
  loadTxns,
}) => {
  return (
    <div className="row p-0 m-0 w-100">
      {/* Received Column */}
      <div
        className="col-6 list-group list-group-flush scrollbar-design overflow-auto ps-4 pe-0 px-md-3"
        style={{
          height: "calc(100vh - 225px)",
          maxHeight: "calc(100vh - 225px)",
        }}
      >
        <ListHeader type="in" amount={monthlyCash.in} title="Received" />
        <OpenCloseBalance type="open" sum={openBalance} />
        {txns
          ?.filter((txn) => txn.amount > 0)
          ?.map((txn, i) => (
            <Txn
              data={txn}
              key={txn.id || i}
              handleToggle={handleToggle}
              setLoading={setLoading}
              loadTxns={loadTxns}
            />
          ))}
      </div>

      {/* Given Column */}
      <div
        className="col-6 list-group list-group-flush scrollbar-design overflow-auto pe-0 px-md-3"
        style={{
          height: "calc(100vh - 225px)",
          maxHeight: "calc(100vh - 225px)",
        }}
      >
        <ListHeader type="out" amount={monthlyCash.out} title="Given" />
        {txns
          ?.filter((txn) => txn.amount < 0)
          ?.map((txn, i) => (
            <Txn
              data={txn}
              key={txn.id || i}
              handleToggle={handleToggle}
              setLoading={setLoading}
              loadTxns={loadTxns}
            />
          ))}
        <OpenCloseBalance type="close" sum={closeBalance} />
      </div>
    </div>
  );
};

export default TxnsTView;
